<template>
  <div class="container mescroll-touch">
    <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
      <div class="banner">
        <van-swipe class="banner-swipe" :autoplay="3000" indicator-color="#333333">
          <!-- <van-swipe-item>
            <img class="banner-img" :src="baseURL + details.ImgUrl" />
          </van-swipe-item> -->
          <van-swipe-item v-for="(item, index) in bannerList" :key="index" @click="toBanner(item.Type, item.Url)">
            <img class="banner-img" :src="baseURL + item.Img" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="square_consult">
        <div class="square_consult_title">在线直播</div>
        <div class="square_tab_scroll" ref="wrapper">
          <div class="square_tab_wrapper">
            <span :class="{ 'active': SubjectTCode == 1 }" @click="changeTab(1)">直播</span>
            <span :class="{ 'active': SubjectTCode == 2 }" @click="changeTab(2)">直播回顾</span>
          </div>
        </div>
        <div class="square_consult_box">
          <div class="right_Consult" v-for="(item, index) in list" :key="index"
            @click="toLive(item.LiveUrl, item.ArticleId)">
            <div class="picture">
              <img :src="baseURL + item.CoverUrl" />
            </div>
            <div class="base">
              <div class="title van-multi-ellipsis--l2">
                <span class="top" v-if="item.IsTop">置顶</span>{{ item.Title }}
              </div>
              <div class="info">
                <span class="time" v-if="item.Date">{{ item.Date }}</span>
              </div>
              <div class="worktype" :class="{ 'red': item.StatusStr == '直播中' }"
                v-if="item.StatusStr != '已结束' && item.StatusStr != '未开始'">{{
                  item.StatusStr }}</div>
              <div class="yytype">
                <button class="yybtn" @click.stop="yybtnfunc(item.ArticleId)"
                  v-if="SubjectTCode == 1 && item.StatusStr == '未开始' && item.IsReservation == false">预约</button>
                <button class="yybtndisable"
                  v-if="SubjectTCode == 1 && item.StatusStr == '未开始' && item.IsReservation == true">已预约</button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </mescroll-vue>
    <img class="share" src="../../assets/images/circle_share.png" @click="showSharePanel = true" />
    <SharePanel :show="showSharePanel" @close="closeSharePanel" />
  </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
import BScroll from 'better-scroll'
import MescrollVue from 'mescroll.js/mescroll.vue'
import SharePanel from '@/components/sharePanel.vue'
export default {
  name: 'HotspotInformation',
  data() {
    return {
      baseURL: process.env.VUE_APP_BASE_URL,
      details: {},
      bannerList: [],
      SubjectTCode: 1,
      list: [],
      PageIndex: 0,
      PageSize: 10,
      mescroll: null, // mescroll实例对象
      mescrollDown: {
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
        callback: this.upCallback, // 上拉回调
        page: {
          num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 10 //每页数据条数,默认10
        },
        noMoreSize: 0,
        toTop: {
          warpId: 'toTop',
          src: './static/image/top_comm_icon@2x.png' // 回到顶部按钮的图片路径,支持网络图
        }
      },
      showSharePanel: false
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue,
    SharePanel
  },
  computed: {
    code() {
      return this.$route.query.code;
    },
    tcode() {
      return this.$route.query.Tcode;
    },
  },
  watch: {
    SubjectTCode() {
      this.list = [];
      this.mescroll.resetUpScroll() // 刷新列表数据
    },
  },
  created() {
    this.initShare("华肤荟", "有心有料有趣有爱");
    document.title = "华肤荟";
    this.getBanner();
    if (this.code) {
      this.getColumn();
    }
  },
  methods: {
    getBanner() {
      this.$axios.get('/api/api/web/content/LiveBannerList?subjectTCode=' + this.tcode).then(res => {
        this.bannerList = res.Data;
      })
    },
    toBanner(type, url) {
      if (type == 20) {
        this.$router.push({
          path: 'live',
          query: {
            id: url,
            type: 1
          }
        });
      } else {
        if (url != null && url != '' && url != undefined) {
          location.href = url;
        }
      }
    },
    initBScroll() {
      this.$nextTick(() => {
        this.scroll = new BScroll(this.$refs['wrapper'], {
          startX: 0,
          click: true,
          scrollX: true,
          scrollY: false,
          eventPassthrough: 'vertical'
        })
      })
    },
    yybtnfunc(id) {
      let that = this;
      this.$axios.post('/api/api/web/content/LiveReservation', {
        ArticleId: id
      }).then(res => {
        this.$dialog
          .alert({
            title: "提示",
            message: "预约成功！",
          })
          .then(() => {
            that.getList(1, 10)
          });
      })
    },
    getColumn() {
      this.$axios.get(`/api/api/web/content/SubjectDetail?code=${this.code}`).then(res => {
        this.details = res.Data;
        this.initBScroll();
        this.initShare(this.details.Title);
      })
    },
    changeTab(type) {
      this.SubjectTCode = type;
    },
    getList(PageIndex, PageSize) {
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;
      if (this.SubjectTCode == 1) {
        this.$axios.post('/api/api/web/content/GetLiveSearchList', {
          PageIndex: this.PageIndex,
          PageSize: this.PageSize,
          TCode: this.tcode
        }).then(res => {
          if (PageIndex === 1) this.list = []
          this.list = this.list.concat(res.Data.List);
          this.$nextTick(() => {
            this.mescroll.endSuccess(res.Data.List.length)
          })
        })
      } else {
        this.$axios.post('/api/api/web/content/GetLiveReviewSearchList', {
          PageIndex: this.PageIndex,
          PageSize: this.PageSize,
          TCode: this.tcode
        }).then(res => {
          if (PageIndex === 1) this.list = []
          this.list = this.list.concat(res.Data.List);
          this.$nextTick(() => {
            this.mescroll.endSuccess(res.Data.List.length)
          })
        })
      }
    },
    // mescroll组件初始化的回调,可获取到mescroll对象
    mescrollInit(mescroll) {
      this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    // 上拉回调
    upCallback(page) {
      this.getList(page.num, page.size);
    },
    toDetail(info) {
      console.log('跳转详情')
      if (info.isOuterChain) {
        location.href = info.outerChain;
      } else {
        this.$router.push({
          path: 'informationDetails',
          query: {
            code: info.Code
          }
        });
      }
    },
    toLive(id, articleId) {
      this.$axios
        .post("/api/api/web/BuriedPoint/AddBP", {
          BPType: 2,
          Name: '资讯点击',
          TCode: 'article',
          Rid: articleId,
        }).then(res => {
          this.$router.push({
            path: 'live',
            query: {
              id: id,
              type: this.SubjectTCode,
              articleId: articleId
            }
          });
        })
    },
    closeSharePanel() {
      this.showSharePanel = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  height: 100%;
  background-color: #f7f8fc;
  padding: 12px;
  box-sizing: border-box;

  .banner {
    .banner-swipe {
      .banner-img {
        display: block;
        width: 100%;
      }
    }
  }

  .square_consult {
    .square_consult_title {
      color: #1f2b5b;
      font-size: 18px;
      font-weight: 600;
      margin: 15px 0 10px;
    }

    .square_tab_scroll {
      display: flex;
      flex-wrap: nowrap;
      overflow: hidden;
      margin-bottom: 8px;
      margin-top: -6px;
      padding: 6px 0;

      .square_tab_wrapper {
        white-space: nowrap;
      }

      span {
        position: relative;
        color: #435361;
        font-size: 16px;
      }


      span:not(:first-of-type) {
        margin-left: 20px;
      }

      .active {
        color: #1D2A5A;
      }

      .active::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: -6px;
        transform: translateX(-16px);
        width: 32px;
        height: 3px;
        border-radius: 3px;
        background: #1f2b5b;
      }
    }

    /* 隐藏水平滚动条 */
    .square_tab_scroll::-webkit-scrollbar {
      display: none;
    }

    .square_consult_box {
      .right_Consult {
        display: flex;
        border-radius: 8px;
        box-shadow: 0 5px 8px 0 rgba(0, 0, 0, .04);
        margin-bottom: 10px;
        padding: 10px;
        background-color: #FFFFFF;
        box-sizing: border-box;

        .base {
          display: flex;
          flex-direction: column;
          // justify-content: space-between;
          flex: 1;
          padding: 0 3%;
          position: relative;

          .worktype {
            bottom: 0;
            position: absolute;
            font-size: 17px;
            color: #959595;
          }

          .red {
            color: red;
          }

          .title {
            color: #0c2941;
            font-size: 15px;
            font-weight: 500;
            line-height: 22px;

            .top {
              background: #1f2b5b;
              border-radius: 2px;
              font-size: 12px;
              color: #fff;
              padding: 3px;
              margin-right: 5px;
            }
          }

          .info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 3%;

            .source_box {
              display: flex;
              align-items: center;
              min-width: 25px;
              max-width: 70%;
              height: 25px;
              border-radius: 25px;
              background: #f6f6f6;

              .source_icon {
                width: 16px;
                height: 16px;
                border-radius: 50%;
                margin: 0 5px;
                background-color: #fff;
              }

              .source_title {
                font-size: 12px;
                color: #435361;
                margin: 0 10px 0 5px;
              }
            }

            .time {
              font-size: 12px;
              color: #435361;
            }
          }
        }

        .picture {
          flex-shrink: 0;
          width: 45%;
          // height: 80px;
          border-radius: 10px;
          overflow: hidden;
          // margin-left: 10px;

          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .share {
    position: fixed;
    right: 10px;
    bottom: 120px;
    width: 40px;
    height: 40px;
    z-index: 100;
  }
}

.yybtn {
  background: rgb(36, 41, 95);
  color: #fff;
  font-size: .42rem;
  border: 0;
  padding: 0.05rem 0.2rem;
  z-index: 99;
  position: relative;
  border-radius: 3px;
  width: 40%;
  transform: translateX(10px);
}

.yybtndisable {
  background: unset;
  color: #ddd;
  font-size: .42rem;
  border: 0;
  padding: 0.05rem 0.2rem;
  z-index: 99;
  position: relative;
  border-radius: 3px;
  width: 40%;
  transform: translateX(10px);
}

.worktype {
  bottom: 2%;
  position: absolute;
  font-size: 17px;
  color: #959595;
  right: 1%;
  z-index: 99;
}

.yytype {
  width: 100%;
  text-align: right;
}
</style>